<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="img/brand/logo.png" alt="logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a
            href="https://demos.creative-tim.com/vue-argon-design-system/documentation/"
          >
            <img src="img/brand/blue.png" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">

              <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="/"
            rel="noopener"
            data-toggle="tooltip"
            title="Home"
            >Home</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="/about-us"
            rel="noopener"
            data-toggle="tooltip"
            title="About us"
            >About Us</a
          >
        </li>

        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">Services</span>
          </a>
          <div class="dropdown-menu-inner">
            <a
              href="/software-services"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-primary rounded-circle text-white"
              >
                <i class="ni ni-spaceship"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-primary mb-md-1">Software Services</h6>
                <p class="description d-none d-md-inline-block mb-0">
                 Customized Software Solution for Your Business.
                </p>
              </div>
            </a>

          <a
              href="/application-modernization"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-primary rounded-circle text-white"
              >
                <i class="ni ni-spaceship"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Application Modernization</h5>
                <p class="description d-none d-md-inline-block mb-0">
                  practice of updating older software for newer computing approaches.
                </p>
              </div>

            </a>


            <a href="/technology-consulting" class="media d-flex align-items-center">
              <div
                class="icon icon-shape bg-gradient-warning rounded-circle text-white"
              >
                <i class="ni ni-ui-04"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Technology Consulting</h5>
                <p class="description d-none d-md-inline-block mb-0">
                  Solve critical business challenges by leveraging right technology.
                </p>
              </div>
            </a>
            <a href="/office365-consulting" class="media d-flex align-items-center">
              <div
                class="icon icon-shape bg-gradient-warning rounded-circle text-white"
              >
                <i class="ni ni-ui-04"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Office 365 Consulting</h5>
                <p class="description d-none d-md-inline-block mb-0">
                  Boost productivity, workflow, and business operations with InfomazeOne’s Office 365 cloud services and solutions.
                </p>
              </div>
            </a>


            
          </div>
        </base-dropdown>

          <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="/pricing"
            rel="noopener"
            data-toggle="tooltip"
            title="Pricing"
            >Pricing</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="/careers"
            rel="noopener"
            data-toggle="tooltip"
            title="Careers"
            >Careers</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="/university"
            rel="noopener"
            data-toggle="tooltip"
            title="SMAKINTEL University"
            >University</a
          >
        </li>

      </ul>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="/contact-us"
            rel="noopener"
            data-toggle="tooltip"
            title="Like us on Facebook"
            >Contact Us</a
          >
        </li>

        <!--<li class="nav-item d-none d-lg-block ml-lg-4">
          <a
            href="https://client.smakintel.com"
            target="_blank"
            rel="noopener"
            class="btn btn-neutral btn-icon"
          >
            <span class="btn-inner--icon">
              <i class="fa fa-cloud-download mr-2"></i>
            </span>
            <span class="nav-link-inner--text">Client Login</span>
          </a>
        </li>-->
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
};
</script>
<style>
</style>
